import { Space } from './src/Space.ts';

customElements.define('dockit-space', Space);
